import React, { useEffect, useState } from 'react';
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import {Col, Row, Card, CardBody, Modal, CardHeader, ModalHeader, ModalBody, ModalFooter, Form, Label, Input} from 'reactstrap';
import {Link, useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import groups from 'variables/groups';
import jQuery from 'jquery';
import './group.css';
import axios from 'axios';
import { BASE_URL } from '../../utils/constants';


const Group = () => {

  const [permissions, SetPermission] = useState({});
  const [perms, SetPerms] = useState({});
  const [group, setGroup] = useState({id: '', name: '', poster: '', icon: ''});
  const [members, setMembers] = useState([]);
  const [project, setProject] = useState([{id: '', name: '', description: ''}]);
  const [selectedPrefs, setSelectedPrefs] = useState({
    template: 'Default',
    bgcolor: '#ffffff',
    fgcolor: '#000000'
  });
  const [projects, setProjects] = useState([]);
  const [proId, setProId] = useState('');
  const [modal, setModal] = useState(false);
  const { id } = useParams();
  const [memberId, setMemberId] = useState('');
  const [posterModal, setPosterModal] = useState(false);
  const [iconModal, setIconModal] = useState(false);
  const [modalPrefs, setModalPrefs] = useState(false);
  const [permModal, setPermModal] = useState(false);
  const [hashes, setHashes] = useState([]);

  useEffect(async()=>{
    try {
      let perm =await axios.post(`${BASE_URL}/group/getProjectPerms.php`,{groupid:id});
        SetPermission(perm.data.data.perms);

      let res = await axios.post(`${BASE_URL}/group/getdetails.php`, {gid: id});
     
      setGroup((res.data.data.group)[0]);
      setMembers(res.data.data.members);
      setProjects(res.data.data.projects);
      setHashes(res.data.data.hashes);
      //setSelectedPrefs(res.data.data.prefs)
    } catch(e) {
      
      Swal.fire('Something Went Wrong!', '', 'error');
    }
  }, []);


  const handlePermissions = (std) => {
    setMemberId(std.id);
    SetPerms(std);
    setPermModal(true);
  }


  const handlePrefs = (e, obj) => {
    e.preventDefault();
    setProId(obj.id);
   
    if(obj.bgcolor && obj.fgcolor && obj.template){
      setSelectedPrefs({template: obj.template,
      bgcolor: obj.bgcolor,
      fgcolor: obj.fgcolor})
    }
    setModalPrefs(true);
  }

  const handlSelect = async(e) => {
    const name = e.target.name;
    const value = e.target.value;
    setSelectedPrefs(prevState => ({...prevState, [name]: value}));
  }

  const handleProject = async (obj) => {
    setProject(obj);
    await setModal(true);
    let cont = jQuery.parseHTML(obj.description);
   
    let par = document.getElementById('description');
    cont.forEach(el => {
      par.appendChild(el);
    })
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let dataF = new FormData();
    let imageFile = document.querySelector('#file');
    dataF.append('attachment', imageFile.files[0]);
    dataF.append('id', id);
    if(posterModal) {
      dataF.append('type', 'poster');
    } else if(iconModal){
      dataF.append('type', 'icon');
    }

    try {
        Swal.showLoading();
        let res = await axios.post(`${BASE_URL}/group/changephotos.php`, dataF, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
        });
        await Swal.fire('Changed Successfully!', '', 'success');
        setGroup(res.data.data);
    } catch {
      Swal.fire('Something Went Wrong', '', 'error');
    } finally {
      if(posterModal) {
        setPosterModal(false)
      } else if(iconModal){
        setIconModal(false)
      }
    }
  }

  const handleSubmitPrefs = async (e) => {
    e.preventDefault();
    let body = {
      proId: proId,
      groupId:group.id,
      template: selectedPrefs.template,
      bgcolor: selectedPrefs.bgcolor,
      fgcolor: selectedPrefs.fgcolor
    }

    try {
      await axios.post(`${BASE_URL}/group/setprojectprefs.php`, body);
      await Swal.fire('Prefrences Stored Successfully!', '', 'success');
    } catch {
      await Swal.fire('Error while sending prefrences', '', 'error');
    } finally {
      setModalPrefs(false);
    }
  }

  const handleSubmitPerms = async (e) => {
    e.preventDefault();
    let intro = document.querySelector('#intro').checked,
        project = document.querySelector('#project').checked,
        aschool = document.querySelector('#aschool').checked,
        elac = document.querySelector('#elac').checked,
        math = document.querySelector('#mcon').checked,
        sse = document.querySelector('#sse').checked,
        eandt = document.querySelector('#et').checked;

    let body = {
      stId: memberId,
      groupid:id,
      write_intro: intro,
      write_project: project,
      write_aschool: aschool,
      write_ela: elac,
      write_math: math,
      write_sse: sse,
      write_eandt: eandt,
    }
    try {
    
      await axios.post(`${BASE_URL}/group/setpermissions.php`, body);
      await Swal.fire('Permissions Stored Successfully!', '', 'success');
    } catch {
      await Swal.fire('Error while sending permissions', '', 'error');
    } finally {
      setPermModal(false);
    }
  }

  return(
    <>
    <PanelHeader size="sm" />
    <div className="content">
      <Row>
        <Col xs={12} className="text-center group-head">
          <div><img style={{maxHeight: '220px', width: '100%'}} src={group.poster? group.poster?.includes("https://")? group.poster :`https://drive.google.com/uc?id=${group.poster}&export=download`:'https://tse3.mm.bing.net/th?id=OIP.w-obtqd1PWCTjTyGeQr7DAHaDb&pid=Api&P=0'} alt='group-poster'/></div><br />
          <div className='images-btns'>
            <button className="btn btn-primary fw-bold fs-6 img-btn" onClick={() => setPosterModal(true)}>
              Change Poster
            </button>
            <button className="btn btn-primary fw-bold fs-6 img-btn" onClick={() => setIconModal(true)}>
              Change Icon
            </button>
          </div>
          <div>
            <img className="rounded-circle responsive" src={group.icon?group.icon?.includes("https://")?group.icon:`https://drive.google.com/uc?id=${group.icon}&export=download`:`https://tse3.mm.bing.net/th?id=OIP.zIHkOyk15JIO0uwHxYODJQHaHa&pid=Api&P=0`} alt='group-icon' style={{maxWidth: '150px', maxHeight: '150px', position: 'relative', bottom: '150px', marginBottom: 0}}/>
            <h3 className='fw-bolder' style={{position: 'relative', bottom: '75px'}}>{group.name}</h3>
          </div>
        </Col>
        </Row>
        <Row>
        <Col xs={12}>
          <Card>
            <CardHeader style={{fontSize: '18pt', fontWeight: 'bolder'}}>Members</CardHeader>
            <hr />
            <CardBody>
              <ul>
                {members.map((member, key) => {
                  return (
                    <li key={key} className='row gap-5'>
                      <h5 className='col-6 fs-5 fw-bold'>{member.fullname}</h5> {(+permissions.group_leader == 1) && <button className='col-2 btn btn-success fw-bold fs-6' onClick={()=>{
                      handlePermissions(member)
                    }}>Permissions</button>}</li>
                  );
                })}
              </ul>
            </CardBody>
          </Card>
        </Col>
        </Row>
        <Row>
        <Col xs={12}>

        <Card>
            <CardHeader style={{fontSize: '18pt', fontWeight: 'bold'}}>Projects</CardHeader>
            <hr />
            <CardBody>
              <ol>
                {projects.map((project, key) => {
                  return (
                    <li key={key} className='row gap-2'>
                      <button className="btn btn-info fw-bolder col-2" onClick={()=>handleProject(project)}>{project.name}</button>
                      <Link className="btn btn-success fw-bolder col-2" to={`/groups/${id}/p/${project.id}`}>Progress</Link>
                      <button className="btn btn-primary fw-bolder col-2" onClick={(e)=>handlePrefs(e, project)}>Preferences</button>
                      <a className="btn btn-secondary fw-bolder col-2" target='_blank' href={`https://student.ivyis.org/preview.php?id=${hashes[key]}`}>Preview</a>
                    </li>
                  );
                })}
              </ol>
              </CardBody>
            </Card>
        </Col>
        </Row>

          {/* **************************Description Modal************************ */}
          <Modal isOpen={modal} size="fullscreen" className="custom-modal-style">
            <ModalHeader className="bg-info fw-bolder">Project Details</ModalHeader>
            <ModalBody>
              <div>
                <div id="description" className="descrip text-center">
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="btn btn-secondary" onClick={()=> setModal(false)}>Close</button>
            </ModalFooter>
          </Modal>

          {/* ******************************Change Images Modal*********************** */}
          <Modal isOpen={posterModal || iconModal} className="upload-image-modal">
            {(posterModal) ? <ModalHeader>Change Poster</ModalHeader> : <ModalHeader>Icon Poster</ModalHeader>}
            <ModalBody>
              <div className="text-center">
                {(posterModal) ? <p className="text-primary fw-bolder">Best height (220) px.</p> : <p className="text-primary fw-bolder">Best fit (150 x 150) px.</p>}
              </div>
              <Form onSubmit={(e) => handleSubmit(e)}>
                {(posterModal) ? <Label>Upload Poster:</Label> : <Label>Upload Icon:</Label>}
                <Input type='file' name='attachment' id='file' />
                <Input type='submit' value='Submit' className='btn btn-primary mt-2 text-center fw-bolder' />

              </Form>
            </ModalBody>
            <ModalFooter>
            {(posterModal) ? <button className="btn btn-secondary" onClick={()=> setPosterModal(false)}>Close</button> : <button className="btn btn-secondary" onClick={()=> setIconModal(false)}>Close</button>}

            </ModalFooter>
          </Modal>

          {/* **********************Prefs Modal********************** */}
          <Modal isOpen={modalPrefs} size="md" className="pref-modal">
            <ModalHeader className="bg-info fw-bolder">Project Preferences</ModalHeader>
            <ModalBody>
              <Form onSubmit={(e)=>handleSubmitPrefs(e)}>
                <Label htmlFor='templ'>Select Template:</Label>
                <Input id='templ' name='template' onChange={(e)=>handlSelect(e)} value={selectedPrefs.template} type='select'  required>
                  <option defaultValue={true} value='Default'>Default</option>
                </Input>
                <br />
                <Label htmlFor='bgclr'>Select Background-Color:</Label>
                <Input id='bgclr' name='bgcolor' onChange={(e)=>handlSelect(e)} type='color' value={selectedPrefs.bgcolor}>
                </Input>
                <br />
                <Label htmlFor='fgclr'>Select Foreground-Color:</Label>
                <Input id='fgclr' name='fgcolor' onChange={(e)=>handlSelect(e)} type='color' value={selectedPrefs.fgcolor}>
                </Input>
                <br />
                <Input type="submit" value="submit" className="btn btn-primary mt-1 mx-auto fs-6 fw-bolder"/>
              </Form>
            </ModalBody>
            <ModalFooter>
              <button className="btn btn-secondary" onClick={()=> setModalPrefs(false)}>Close</button>
            </ModalFooter>
          </Modal>

           {/* **********************Permissions Modal********************** */}
           <Modal isOpen={permModal} size="lg" className="perm-modal">
            <ModalHeader className="bg-info fw-bolder">Member Permissions</ModalHeader>
            <ModalBody>
              <Form onSubmit={(e) => handleSubmitPerms(e)}>
                <Row className='fs-6 fw-bold'>
                <Col md={6}><Label htmlFor='intro'>Introduction</Label></Col>
                <Col md={6}><Input type='checkbox' id='intro' name='write_intro' defaultChecked={perms.write_intro== "1"}/></Col>
                <Col md={6}><Label htmlFor='project'>Project</Label></Col>
                <Col md={6}><Input type='checkbox' id='project' name='write_project'  defaultChecked={perms.write_project=="1"}/></Col>
                <Col md={6}><Label htmlFor='aschool'>About School</Label></Col>
                <Col md={6}><Input type='checkbox' id='aschool' name='write_aschool'  defaultChecked={perms.write_aschool=="1"}/></Col>
                <Col md={6}><Label htmlFor='elac'>ELA Connection</Label></Col>
                <Col md={6}><Input type='checkbox' id='elac' name='write_ela'  defaultChecked={perms.write_ela=="1"}/></Col>
                <Col md={6}><Label htmlFor='mcon'>Math Connection</Label></Col>
                <Col md={6}><Input type='checkbox' id='mcon' name='write_math'  defaultChecked={perms.write_math=="1"}/></Col>
                <Col md={6}><Label htmlFor='sse'>S.S.E</Label></Col>
                <Col md={6}><Input type='checkbox' id='sse' name='write_sse'  defaultChecked={perms.write_sse=="1"}/></Col>
                <Col md={6}><Label htmlFor='et'>Engineering &amp; Technologies</Label></Col>
                <Col md={6}><Input type='checkbox' id='et' name='write_eandt'  defaultChecked={perms.write_eandt=="1"}/></Col>
                </Row>
                <br />
                <Input type="submit" value="submit" className="btn btn-primary mt-1 mx-auto fs-6 fw-bolder"/>
              </Form>
            </ModalBody>
            <ModalFooter>
              <button className="btn btn-secondary" onClick={()=> setPermModal(false)}>Close</button>
            </ModalFooter>
          </Modal>
    </div>


    </>
  );
};

export default Group;